import { defineMessages } from '@dragonraider5/react-intl'

export default defineMessages({
  formTitle: {
    id: 'containers.Login.form.title',
    description: 'Login form title',
    defaultMessage: 'Iniciar sesión'
  },
  formFieldUsername: {
    id: 'containers.Login.form.fields.username',
    description: 'Login form username field',
    defaultMessage: 'E-mail'
  },
  formFieldPassword: {
    id: 'containers.Login.form.fields.password',
    description: 'Login form password field',
    defaultMessage: 'Contraseña'
  },
  formButtonSubmit: {
    id: 'containers.Login.form.buttons.submit',
    description: 'Login form button submit',
    defaultMessage: 'Iniciar sesión'
  },
  registerLink: {
    id: 'containers.Login.form.links.register',
    description: 'Login form register link',
    defaultMessage: '¿No tienes usuario todavía?'
  }
})
